<script>
export default defineComponent({
  name: 'AddToCartButton',
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    totalPrice: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const cart = useCartStore()

    const submitting = ref(false)
    const handleAddToCart = async () => {
      submitting.value = true
      await cart.addToCart(props.data)
      submitting.value = false
    }

    return {
      handleAddToCart,
      submitting
    }
  }
})
</script>

<template>
  <AppButton
    full-width
    class="mt-8"
    :disabled="disabled"
    :loading="submitting"
    @click="handleAddToCart"
  >
    {{ $t('component.tickets.transport.button.submit') }} {{ formatCurrency(totalPrice) }}
  </AppButton>
</template>

<style scoped lang="scss">

</style>
